export type StudentNotesModalTabKey = 'summary' | 'history';

export const STUDENT_NOTES_MODAL_TABS = [
  { key: 'summary' as const, label: 'Resumo' },
  { key: 'history' as const, label: 'Histórico' },
];
